import {AfterViewInit, Component, OnDestroy, SimpleChanges} from '@angular/core';
import {StaticAmplitudeAlarmParameters} from '../../../../../../../shared/classes/alarms/alarm-parameters/static-amplitude-alarm-parameters';
import {AbstractControl, FormBuilder, Validators} from '@angular/forms';
import {AlarmParameterDefaultForm} from '../../../../../../../shared/classes/alarms/alarm-parameters/alarm-parameter-default-form';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-parameters-static-amplitude-alarm',
  templateUrl: './alarm-parameters-form-static-amplitude.component.html',
  styleUrls: ['./alarm-parameters-form-static-amplitude.component.css']
})
export class AlarmParametersFormStaticAmplitudeComponent extends AlarmParameterDefaultForm implements AfterViewInit, OnDestroy {

  params: StaticAmplitudeAlarmParameters;
  paramsChangeSubsc: Subscription;

  constructor(protected formBuilder: FormBuilder) {
    super();
  }

  ngAfterViewInit() {
    this.paramsChangeSubsc = this.paramsChange.subscribe(
      (changes: SimpleChanges) => {
        if (changes.params) {
          this.form.get('threshold').setValue(changes.params.currentValue.threshold);
          this.form.get('period').setValue(changes.params.currentValue.period);
          this.form.get('channel').setValue(changes.params.currentValue.channel);

        }
      });
  }

  ngOnDestroy() {
    this.paramsChangeSubsc.unsubscribe();
  }

  mapAlarmParamsToForm() {
    this.params = this.params ? this.params : new StaticAmplitudeAlarmParameters();
    const integerValidator = (control: AbstractControl) => isNaN(control.value) ? {'not a number': true} : null;
    this.form = this.formBuilder.group({
        threshold: [{value: this.params.threshold, disabled: this.readOnly}, [Validators.required, integerValidator]],
        period: [{value: this.params.period, disabled: this.readOnly}, [Validators.required, Validators.pattern('[1-9]*')]],
        channel: [{value: this.params.channel, disabled: this.readOnly}, [Validators.pattern('[0-1]*')]]
      }
    );
  }

}
